import { render } from "./VideoDownloadButton.vue?vue&type=template&id=2f7da48e"
import script from "./VideoDownloadButton.vue?vue&type=script&lang=js"
export * from "./VideoDownloadButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__